import React from 'react';

export default function Header() {
  return (
    <header className="h-16 border-b bg-card flex items-center px-6 justify-between">
      <h2 className="text-lg font-semibold">Gestão de Frota</h2>
    </header>
  );
}
